import { SECTIONS } from "@/config/constants";

/**
 * Build a Strapi `filters` object for the chosen explore section.
 * "Both" (or no choice) → no filter (show everything).
 * Products and Designers both carry a single-value `section` enum.
 */
export const sectionFilter = (section) =>
  !section || section === SECTIONS.BOTH ? undefined : { section: { $eq: section } };
